import React, { createContext, useState, useCallback, Fragment, useContext } from 'react';
import { AnimatePresence } from 'framer-motion';

import TailwindcssBlock from 'components/Tailwindcss/Block';
import Alert from './Alert';

export const ALERT_TYPES = {
  ALL: '',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const NotificationAlertsContext = createContext({ alerts: [] });

let alertId = 0;

export const NotificationProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const createAlert = useCallback((text, type = ALERT_TYPES.INFO, time) => {
    setAlerts(_alerts =>
      _alerts.concat({
        text,
        type: type === ALERT_TYPES.ALL ? ALERT_TYPES.INFO : type,
        time,
        id: ++alertId,
      }),
    );
  }, []);

  const deleteAlert = useCallback(id => {
    setAlerts(_alerts => _alerts.filter(alert => alert.id !== id));
  }, []);

  return (
    <NotificationAlertsContext.Provider value={{ alerts, createAlert, deleteAlert }}>
      <Fragment>{children}</Fragment>
    </NotificationAlertsContext.Provider>
  );
};

export const NotificationAlerts = ({ filter = ALERT_TYPES.ALL }) => {
  const { alerts, deleteAlert } = useContext(NotificationAlertsContext);

  return (
    <TailwindcssBlock
      fixed
      top-0
      w-full
      max-w-md
      max-h-full
      style={{ zIndex: 102, left: '50%', transform: 'translateX(-50%)' }}
    >
      <div>
        <AnimatePresence>
          {alerts
            .filter(alert => {
              if (filter === ALERT_TYPES.ALL) {
                return true;
              }

              return alert.type === filter;
            })
            .map(alert => (
              <Alert key={alert.id} alert={alert} deleteAlert={deleteAlert} />
            ))}
        </AnimatePresence>
      </div>
    </TailwindcssBlock>
  );
};
